<template>
    <div class="vx-row ml-0 mr-0" :key="index">
        <immiInput :fieldsArray="questionnaireDetails"  :required="true" :tplsection="tplsection" :tplkey="'institutionName'" :dispaly="false" wrapclass="md:w-1/2" :cid="'institutionName'+index" :formscope="formscope" v-model="value.institutionName" :fieldName="'institutionName'+index" label="Institution Name" placeHolder="Institution Name"/>
        <selectField :tplkey="'stateDetails'" :display="false" :fieldsArray="questionnaireDetails"  :required="true" :optionslist="instituteStates" @input="loadinstitueCitiStateId(value.stateDetails);value.stateId = checkProperty(value, 'stateDetails', 'id')" v-model="value.stateDetails" :tplsection="tplsection"  :fieldName="'stateDetails'"  :formscope="formscope"  label="State" placeHolder="State" />
        <selectField :tplkey="'locationDetails'" :display="false" :fieldsArray="questionnaireDetails" :isDisabled="!checkProperty(value, 'stateDetails')" :required="true" :optionslist="instituteLocations" @input="value.locationId = checkProperty(value, 'locationDetails', 'id')" v-model="value.locationDetails" :tplsection="tplsection"  :fieldName="'locationDetails'"  :formscope="formscope"  label="City" placeHolder="City" />
        <datepickerField :fieldsArray="questionnaireDetails"  :display="false" :tplkey="'dateFrom'" wrapclass="md:w-1/2" :tplsection="tplsection"  v-model="value.dateFrom" :required="true" :dateEnableTo="new Date()"  :formscope="formscope" @input="clearDependentField()"  :fieldName="'dateFrom' + index" label="Date From" :validationRequired="true" />
        <datepickerField :fieldsArray="questionnaireDetails"  :display="false" :tplkey="'dateTo'" wrapclass="md:w-1/2" :tplsection="tplsection"   v-model="value.dateTo" :isDisabled="!value.dateFrom" :dateEnableFrom="value.dateFrom" :formscope="formscope" :required="true" :fieldName="'dateTo' + index" label="Date To" :validationRequired="true"/>
        <immiInput :fieldsArray="questionnaireDetails"  :required="true" :tplsection="tplsection" :tplkey="'reason'" :dispaly="false" wrapclass="md:w-1/2" :cid="'reason'+index" :formscope="formscope" v-model="value.reason"  :fieldName="'reason'+index" label="Reason" placeHolder="Reason"/>
    </div>
</template>
<script>
import immiInput from "@/views/forms/fields/simpleinput.vue";
import datepickerField from "@/views/forms/fields/datepicker.vue";
import selectField from "@/views/forms/fields/simpleselect.vue";
import moment from "moment";
export default {
    provide() {
        return {
            parentValidator: this.$validator,
        };
    },
    data: () => ({
        instituteLocations:[],
    }),
    computed: {

    },
    components: {
        selectField,
        immiInput,
        datepickerField
    },
    props: {
        index:null,
        instituteStates:{
            type:Array,
            default:[]
        },
        value:null,
        petition: {
            type: Object,
            default: null
        },
        tplsection:{
            type:String,
            default:'beneficiaryInfo'
        },
        questionnaireDetails:{
            type:Array,
            default:[]
        },
        formscope:{
            type:String,
            default:''
        }
    },
    methods:{
        clearDependentField(){   
            if(this.value['dateFrom'] ){
                let startDate = moment(this.value['dateFrom']);
                if(this.value['dateTo'] ){
                    let endDate = moment(this.value['dateTo']);
                    if(startDate.isAfter(endDate , 'day')){
                        this.value['dateTo'] = null;
                    }
                }
            }else{
                this.value['dateTo'] = null;
            }
        },
        addInstituteItem(){
            let obj = {
                institutionName:'',
                stateId:'',
                stateDetails:null,
                locationId:'',
                locationDetails:null,
                dateFrom:null,
                dateTo:null,
                reason:'',
            };
            this.value['periodOfInstutions'].push(obj)
        },
        removeInstituteItem(inde){
            Vue.delete(this.value['periodOfInstutions'], inde);
        },
        loadinstitueCitiStateId(val, callFromMount = false) {
            if(callFromMount == false){
                this.value.locationId = null;
                this.value.locationDetails = null
            }
            this.instituteLocations = [];
            let stateId = this.checkProperty(val, 'id');
            if(stateId){
                this.$store.dispatch("getlocations", {countryId: 231, stateId: stateId})
                .then((response) => {
                    this.instituteLocations = response;
                })
                .catch(() => {});
            }
        },
    },
    mounted(){
        if(this.checkProperty(this.value, 'stateDetails', 'id')){
            this.loadinstitueCitiStateId(this.value['stateDetails'], true)
        }
    }
}
</script>